// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"cad63cbcfe0e2d75","5285":"dc1da3e137a42e9b"}[chunkId] + ".css";
};